'use strict';

function UserRecipients({ client, fspId, recipientId }) {

  return {
    returnModel: {
      name: 'userRecipient',
    },
    baseUrl: `/fsps/${fspId}/recipients/${recipientId}/userrecipients`,

    create: function create(data, queryParams, cb) {
      return client.executeRequest('POST', this.baseUrl, {
        data,
        queryParams,
        cb,
        returnModel: this.returnModel,
      });
    },
  };

}

module.exports = UserRecipients;
